// material
/* eslint-disable */
import { Container } from '@material-ui/core';
import Page from '../components/Page';
import { MainDashboardApp } from '../components/_dashboard/app/index';

// ----------------------------------------------------------------------

export default function DashboardApp() {
  return (
    <Page title="Dashboard |  FAPS">
      <Container maxWidth>
        <MainDashboardApp />
      </Container>
    </Page>
  );
}
